import React from 'react';
import { Deck } from './components/Deck';
export function App() {
  return <Deck data-id="element-0" data-mp="35cbyyjp1a59w" />;
}